import { toast } from "react-toastify";

export function showToast(
  message: string,
  type: "success" | "warning" | "error" = "error"
) {
  toast[type](message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}
